import { useParams } from 'react-router-dom';

export function useGetMemberId() {
  const { id } = useParams();
  const memberId = Number(id);
  return { memberId };
}
